import { Outlet, useNavigate } from "react-router-dom";
import useAppStore from "@/stores/useAppStore";
import { GetMe } from "@/apis/Auth";
import { useEffect } from "react";
import { UserStatusEnum } from "@/types/enum";
import TopNavigation from "@/components/molecules/TopNavigation";
import AccountStatusPage from "@/components/pages/AccountStatusPage";
import useUserStatusCheck from "@/hooks/auth/useUserStatusCheck";

function AuthRoute() {
  const setIsAppLoading = useAppStore((s) => s.setIsAppLoading);
  const setUser = useAppStore((s) => s.setUser);
  const user = useAppStore((s) => s.user);
  const navigate = useNavigate();

  // Periodically check user status
  useUserStatusCheck();

  useEffect(() => {
    if (user) {
      return;
    }
    setIsAppLoading(true);
    GetMe().subscribe({
      next: (res) => {
        setUser(res);
      },
      error: () => {
        setIsAppLoading(false);
        navigate("/");
      },
      complete: () => {
        setIsAppLoading(false);
      },
    });
  }, [user]);

  if (!user) {
    return null;
  }

  // Check if user is inactive or suspended
  const isUserBlocked =
    user.status === UserStatusEnum.INACTIVE ||
    user.status === UserStatusEnum.SUSPENDED;

  if (isUserBlocked) {
    return <AccountStatusPage />;
  }

  // Only active users can access the app
  return (
    <div className="h-screen w-screen flex flex-col">
      <TopNavigation />
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}

export default AuthRoute;
